import { render, staticRenderFns } from "./SaleType.vue?vue&type=template&id=dec4df92"
import script from "./SaleType.vue?vue&type=script&lang=ts"
export * from "./SaleType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dec4df92')) {
      api.createRecord('dec4df92', component.options)
    } else {
      api.reload('dec4df92', component.options)
    }
    module.hot.accept("./SaleType.vue?vue&type=template&id=dec4df92", function () {
      api.rerender('dec4df92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/sale/SaleType.vue"
export default component.exports